import { axios } from 'lib/axios';
import { useQuery } from '@tanstack/react-query';


const getBySlugRequest = async (slug) => {
  try {
    return await axios.get(`/api/blog/${slug}`);
  } catch (error) {
    if (error?.response?.data.description === "record not found") {
      throw new Error("Object doesn't exist");
    }
    
    throw new Error("You don't have permissions to see this object");
  }
};

export const useBlogBySlug = (slug, config = {}) => {
  const configOptions = {select: ({ data }) => data, retry: false, ...config}
  return useQuery({
    queryKey: [`blog-${slug}`],
    queryFn: () => getBySlugRequest(slug),
    ...configOptions
  });
};
